
import { configureStore } from '@reduxjs/toolkit';
import overflowReducer from './overflowBlockSlice';
import blockClassNameReducer from "./blockClassNameSlice"; 
import termReducer from "./termSlice"; 
import { dataApi } from '../api/dataApi';
import scrappingReducer from './scrappingSlice';
import buttonReducer from './buttonSlice';
import buttonNotReducer from './buttonNotSlice';
import appRouteReducer from './appRouteSlice';
import { unsplashApi } from '../api/unsplashApi';
import videoReducer from './videoSlice';
import draftReducer from "./draftSlice";

const store = configureStore({
  reducer: {
    overflow: overflowReducer,
    blockClassName: blockClassNameReducer,
    term: termReducer,
    scrapping: scrappingReducer,
    button: buttonReducer,
    buttonNot: buttonNotReducer,
    appRoute: appRouteReducer,
    videos: videoReducer,
    draft: draftReducer,
    [dataApi.reducerPath]: dataApi.reducer,
    [unsplashApi.reducerPath]: unsplashApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(dataApi.middleware, unsplashApi.middleware),
});

export default store;
